export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-26.c193960a.png";